import React from "react";
import { Container } from "./Styled";

export const AuthorizationDetails: React.FC<{
  amtnottoexceed: number;
  fillup: boolean;
  showSignature?: boolean;
}> = ({ amtnottoexceed, fillup, showSignature }) => {
  return (
    <Container
      style={{
        gridTemplateColumns: "20% 10% 45%",
        gridGap: 15,
        alignItems: "center",
      }}
    >
      <div className="box-1">
        <div>Max Fuel Voucher Amount:</div>
      </div>
      <div className="box-2">
        {fillup
          ? "Fill-up"
          : new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
            }).format(amtnottoexceed)}
      </div>
      {showSignature && (
        <>
          <div className="box-4">Dealership Authorizing:</div>
          <div className="box-5" />
          <div className="box-6">Comments:</div>
        </>
      )}
    </Container>
  );
};
